import React from 'react';
import { motion } from 'framer-motion';
import './HistorySection.css';

const timeline = [
  {
    year: '2015',
    title: 'Company Founded',
    description: 'BairagiConsultants was established with a vision to deliver custom software solutions.'
  },
  {
    year: '2017',
    title: 'First Major CRM Project',
    description: 'Successfully delivered a comprehensive CRM system for a retail chain.'
  },
  {
    year: '2019',
    title: 'Mobile App Division Launched',
    description: 'Expanded our services to include custom mobile application development.'
  },
  {
    year: '2021',
    title: 'Ecommerce Specialization',
    description: 'Developed expertise in building scalable ecommerce platforms.'
  },
  {
    year: '2023',
    title: '100+ Projects Delivered',
    description: 'Reached the milestone of completing over 100 successful projects.'
  }
];

const HistorySection = () => {
  return (
    <section className="history-section">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Our Journey
        </motion.h2>
        
        <div className="timeline">
          {timeline.map((item, index) => (
            <motion.div 
              key={index}
              className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="timeline-year">{item.year}</div>
              <div className="timeline-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HistorySection;